import { subscribeToNewsletter } from "@/services/api/newsletter-subscription/subscribe-to-newsletter";
import { Input } from "antd";
import React, { useState } from "react";
import styles from "./email-subscribe.module.scss";
import { z } from "zod";
import { FaSpinner } from "react-icons/fa";
import { BiCheck } from "react-icons/bi";

type Props = {};

const emailSchema = z.string().min(1, "Please enter an email to subscribe").email("Please enter a valid email");

const EmailSubscribe = (props: Props) => {
  const [prompt, setPrompt] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);

  const handleSetEmail = (value: string) => {
    setPrompt("");
    setEmail(value);
  };

  const showPrompt = (value: string) => {
    setPrompt(value);

    if (timeoutId) {
      clearTimeout(timeoutId); // Clear the previous timeout if it exists
    }

    const newTimeoutId = setTimeout(() => {
      setPrompt("");
      setTimeoutId(null); // Reset the timeout ID after it finishes
    }, 3000);

    setTimeoutId(newTimeoutId); // Store the new timeout ID
  };

  const handleSubscribe = async () => {
    setPrompt("");
    setLoading(true);
    try {
      emailSchema.parse(email);
      const res = await subscribeToNewsletter(email);
      if (!res) {
        setLoading(false);
        showPrompt("Sorry there was an error, please try again");
        return;
      }
      setLoading(false);
      setSuccess(true);
      showPrompt("Thanks! Your email has been subscribed to our newsletter");
      setTimeout(() => {
        setSuccess(false);
      }, 3000);
    } catch (e: any) {
      setLoading(false);
      if (e.errors[0].code === "too_small") {
        showPrompt(e.errors[0].message);
        return;
      }
      if (e.errors[0].code === "invalid_string") {
        showPrompt(e.errors[0].message);
        return;
      }
      //   setError(e.errors);
    }
  };

  return (
    <div className={styles.emailContainer}>
      <div className={styles.emailInput}>
        <Input value={email} onChange={(e) => handleSetEmail(e.target.value)} placeholder="Your email address" />
        <button onClick={handleSubscribe}>Subscribe</button>
        <div className={styles.loader}>
          {success && <BiCheck size={30} className={styles.success} />}
          {loading && <FaSpinner size={30} className={styles.animated} />}
        </div>
      </div>
      {prompt && <div className={styles.error}>{prompt}</div>}
    </div>
  );
};

export default EmailSubscribe;
